import * as React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { isHrefCorrect } from '../utils';
import * as S from './styles';
export const CustomAccordion = (props) => (React.createElement(S.StyledMuiAccordion, Object.assign({ disableGutters: true, elevation: 0, square: true }, props)));
export const CustomAccordionSummary = (props) => {
    const { href } = props;
    return (React.createElement(S.StyledAccordionSummary, Object.assign({ expandIcon: isHrefCorrect(href) ? null : React.createElement(KeyboardArrowDownIcon, null) }, props)));
};
export const CustomAccordionDetails = S.StyledAccordionDetails;
//# sourceMappingURL=index.js.map